import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import StickyPageHeader from '../components/common/StickyPageHeader';
import AuditRatesList from '../components/lists/AuditRatesList';
import { useCarriers, useRateAuditSummary } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminAuditRatesPage = ({ routes }) => {
  const { allCarriers } = useCarriers();
  const { isLoading, refetch } = useRateAuditSummary();

  const handleRefresh = () => {
    refetch();
  };

  return (
    <>
      <StickyPageHeader
        isAdmin
        actions={
          <Button
            icon={<ReloadOutlined />}
            loading={isLoading}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        }
        title="Audit Rates"
      />
      <Layout
        showCarriersNavigation
        disableLoading={true}
        menuIndex={0}
        routes={routes}
      >
        <AuditRatesList carriers={allCarriers} />
      </Layout>
    </>
  );
};

export default AdminAuditRatesPage;
